module.exports = __webpack_public_path__ + "scene.f43c841b.png";